<template>
  <div
    id="dataurl"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <!-- <div
      class="bg-white px-3"
      style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
    >
      <el-tabs v-model="type" @tab-click="handleClick">
        <el-tab-pane label="域名访问" :name="'1'"> </el-tab-pane>
        <el-tab-pane label="下载域名" :name="'2'"></el-tab-pane>
      </el-tabs>
    </div> -->

    <!-- <div class="mb-2 mt-2 pt-3"> -->
    <!-- <button-search
        ref="buttonSearch"
        placeholder="搜索日期"
        @search="searchEvent"
        :showGj="true"
      > -->
    <!-- 左边 -->
    <!-- <template #left>
          <div> -->
    <!-- <div>
								今日数据：
							</div>
							
							
							<div style="display: inline-block;" v-for="(item,index) in now_list" :key="index">
								<span class="mr-3 ">{{index}}：<el-tag type="success"> {{item}} </el-tag></span>
							</div> -->

    <!-- <el-button class="mr-2" @click="checkExcelData()" type="primary" size="mini">
								<i class="el-icon-download mr-1"></i>导出excel</el-button> -->
    <!-- </div> -->

    <!-- <el-button v-show="type==2" class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">新增房间</el-button> -->
    <!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->
    <!-- <el-button class="mr-2" @click="urlModel=!urlModel" type="primary" size="mini">域名显示管理</el-button> -->
    <!-- </template> -->

    <!-- 高级搜索 -->
    <!-- <template #from>
          <el-form inline ref="form" :model="from" label-width="100px">
            <el-form-item label="日期" size="small" class="mb-0">
              <el-date-picker
                v-model="from.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="mb-0">
              <el-button type="info" @click="searchEvent" size="small"
                >搜索
              </el-button>
              <el-button size="small" @click="clearSearch"
                >清空筛选条件</el-button
              >
            </el-form-item>
          </el-form>
        </template> -->
    <!-- </button-search> -->
    <!-- </div> -->

    <!-- <el-card class="box-card" v-show="urlModel">
		<div slot="header" class="clearfix">
		<span class="mr-4">显示域名管理</span>
		<el-button type="success" @click="urlall('1')" size="small">全部显示 </el-button>
		<el-button type="danger" @click="urlall('0')" size="small">全部隐藏 </el-button>
		<el-button style="float: right; padding: 3px 0" @click="urlModel=!urlModel" type="text">收起</el-button>
		</div>
		<div > 
		<el-form inline ref="form" :model="from_other" label-width="350px">
			<el-form-item :label="item.show_url" 
			v-if="item.url!='date'"
			class="mb-0" v-for="(item,index) in url_list" :key="index" >
				
				<el-switch 
					v-model="item.is_show"
					active-value="1"
					inactive-value="0"
					active-color="#13ce66"
					inactive-color="#ff4949">
				</el-switch>
			</el-form-item>
			
			</br>
			<el-form-item class="mb-0">
				<el-button type="primary" @click="editShowUrl()"  size="small">保存 </el-button>
			</el-form-item>
		</el-form>
		</div>
		</el-card> -->

    <div class="sertop">
      <div class="sertop-left">
        <span>网址搜索：</span>
        <el-autocomplete
          class="inline-input"
          v-model="state"
          clearable
          :fetch-suggestions="querySearch"
          placeholder="请输入网址"
          @select="handleSelect"
        ></el-autocomplete>
      </div>
      <div class="sertop-right">
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item label="" size="small" class="mb-0">
            <el-date-picker
              v-model="from.time"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" size="small" @click="searchEvent(from.time)"
              >搜索
            </el-button>
            <el-button size="small" @click="clearSearch"
              >清空筛选条件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格 -->
    <!-- <div class="mt-3 pt-2">
      <el-table
        height="750"
        @sort-change="sortChange"
        @header-click="todetail"
        :default-sort="{ prop: prop, order: sort }"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column fixed type="selection" width="45" align="center">

				</el-table-column>
        <el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>

        <el-table-column align="center" fixed width="120" prop="date" label="日期">
				</el-table-column>

        <el-table-column width="80" align="center" v-for="(item,index) in url_list" :key="index"  
				prop="date" :label="item.show_url" 
				v-if="item.is_show=='1' && item.url!='date' " 
				>
				<template slot-scope="v">
					<span class="font-weight-bolder " @click="todetail(item.url)"
						:class="item.url!='date'?'text-danger':''">{{v.row[item.url]}}</span>
				</template>
			</el-table-column>
      </el-table>
    </div> -->

    <div class="tabsle">
      <template v-if="tableData.length > 0">
        <div
          class="tabsle-cons"
          v-for="(item, index) in tableData.slice(0, 30)"
          :key="index"
        >
          <span>{{ index + 1 }}</span>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.value"
            placement="top-start"
          >
            <el-button>{{ item.value }}</el-button>
          </el-tooltip>
          <!-- <span>{{ item.name }}</span> -->
          <span>{{ item.quantity }}</span>
        </div>
      </template>
      <template v-else>
        <div class="tabsle-none">
          <p>暂无数据</p>
        </div>
      </template>
    </div>

    <!-- <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer> -->

    <!-- 麦位信息 -->
    <el-dialog title="麦位信息" :visible.sync="wheatModel" top="5vh">
      <!-- 表单内容 -->

      <div class="px-3 mb-3">
        <el-row :gutter="20">
          <el-col
            :span="index <= 1 ? 12 : 6"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="grid-content bg-purple text-center mb-3">
              <div>
                <el-avatar
                  v-if="item.user_id > 0"
                  :size="60"
                  :src="item.head"
                ></el-avatar>
                <span
                  v-else
                  class="btn btn-light border mb-1"
                  style="
                    width: 61px;
                    height: 61px;
                    line-height: 61px;
                    border-radius: 100%;
                  "
                >
                  <i class="el-icon-plus" style="font-size: 30px"></i>
                </span>
              </div>
              <div>
                <small>{{ item.name ? item.name : "空位" }}</small>
              </div>
              <div>
                <small class="text-warning">{{ item.wheat_name }}</small>
                <i
                  v-if="item.is_wheat == 0"
                  class="el-icon-turn-off-microphone"
                ></i>
                <i v-if="item.is_lock == 0" class="el-icon-lock"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="wheatModel = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { export2Excel } from "@/common/js/util.js";

import common from "@/common/mixins/common.js";
// import buttonSearch from "@/components/common/button-search.vue";
export default {
  //   components: {
  //     buttonSearch,
  //   },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      type: "1",
      wheat_list: [],
      urlModel: false,
      wheatModel: false,
      createModel: false,
      editIndex: -1,
      from_other: {},
      //搜索数据
      from: {
        user_id: "",
        out_trade_no: "",
        type: 0,
        pay_type: 0,
        is_error: -1,
        is_win: -1,
        time: "",
      },
      prop: "date",
      sort: "descending",
      model_title: "官方房间",
      auth_val: "Pay",
      preUrl: "data/urlList", //列表地址
      delAllUrl: "data/delPayAll", //批量删除地址
      delUrl: "data/delPay", //删除单条地址
      addUrl: "data/addPay", //添加/修改地址
      editStatusUrl: "data/editPay", //修改状态地址

      tableData: [],
      form: {
        headUrl: "",
        headId: 0,
      },
      page: {
        current: 1,
        sizes: [31, 62, 100, 200],
        size: 31,
        total: 0,
      },
      options: [],
      rules: {},
      rule_list: [],
      check_img_list: [],
      list: [],
      loading: false,
      class_list: [],
      total_list: [],
      total_money: 0,

      url_list: [],
      now_list: [],
      state: "",
      restaurants: [],
    };
  },
  watch: {
    activeName(e) {
      console.log(e);
    },
  },
  created() {
    //this.commonList();
  },
  methods: {
    todetail(val) {
      this.layout.toUrl("6", { url: val.label });
    },
    // urlall(val) {
    //   for (var i = 0; i < this.url_list.length; i++) {
    //     if (this.url_list[i].url != "date") {
    //       this.url_list[i]["is_show"] = val;
    //     }
    //   }
    // },
    // exportData() {
    //   let title = "充值统计";
    //   if (this.from.time[0]) {
    //     title =
    //       "充值统计-(" + this.from.time[0] + " 至 " + this.from.time[1] + ")";
    //   }
    //   export2Excel(this.columns, this.excel_list, title);
    // },
    // editShowUrl() {
    //   this.layout.loading = true;
    //   this.api
    //     .post(
    //       "/data/editShowUrl",
    //       {
    //         list: this.url_list,
    //         type: this.type,
    //       }
    //     )
    //     .then((res) => {
    //       this.layout.loading = false;
    //     })
    //     .catch((err) => {
    //       // 失败
    //       console.log(err);
    //       this.layout.loading = false;
    //     });
    // },
    // //获取列表
    // checkExcelData() {
    //   this.layout.loading = true;
    //   this.api
    //     .post(
    //       "/data/paydataExcel",
    //       {
    //         search: this.search,
    //         prop: this.prop,
    //         type: this.type,
    //         sort: this.sort == "ascending" ? "asc" : "desc",
    //       }
    //     )
    //     .then((res) => {
    //       let all = res.data;
    //       let list = all.data.list;

    //       this.excel_list = list.list;
    //       //console.log(list.list)
    //       this.layout.loading = false;
    //     //   this.exportData();
    //     })
    //     .catch((err) => {
    //       // 失败
    //       console.log(err);
    //       this.layout.loading = false;
    //     });
    // },

    handleClick(tab, event) {
      this.search = "";
      this.clearSearch();
      this.urlModel = false;
      this.tableData = [];
      this.url_list = [];
      this.getList();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.api
          .post("/user/searchUser", {
            search: query,
          })
          .then((res) => {
            let all = res.data;
            let list = all.data.list;
            this.options = list;

            this.loading = false;
          })
          .catch((err) => {
            // 失败
            this.loading = false;
          });
      } else {
        this.options = [];
      }
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },

    // 打开模态框
    openModel(e = false) {
      // 增加
      if (!e) {
        // 初始化表单
        this.form = {
          headUrl: "",
          headId: 0,
          bgUrl: "",
          bgId: 0,
          name: "",
          room_id: "",
          user_id: "",
          status: 1,
          is_home: 1,
          is_show: 1,
          classify: 1,
          notice: "",
          room_type: this.type,
          aUrl: "",
          aId: 0,
        };
        this.editIndex = -1;
      } else {
        // 修改
        this.form = {
          headUrl: e.row.cover,
          headId: 0,
          bgUrl: e.row.bg,
          bgId: 0,
          name: e.row.name,
          classify: e.row.classify,
          room_id: e.row.room_id,
          user_id: e.row.user_id,
          status: e.row.status,
          is_home: e.row.is_home,
          is_show: e.row.is_show,
          notice: e.row.notice,
          room_type: this.type,
          aUrl: e.row.attribute,
          aId: 0,
        };

        this.editIndex = e.row.id;
      }
      // 打开dialog
      this.createModel = true;
    },
    // openWheatModel(obj) {
    //   this.anchorList(obj.id);
    // },
    //公共列表
    commonList() {
      this.api
        .post(
          "/room/classTypeList",
          {},
          
        )
        .then((res) => {
          let all = res.data;
          let list = all.data.list;

          this.type_list = list.type_list;
          this.class_list = list.class_list;
        })
        .catch((err) => {
          // 失败
        });
    },
    // anchorList(room_id) {
    //   this.wheatModel = true;
    //   this.layout.loading = true;
    //   this.api
    //     .post(
    //       "/room/anchorList",
    //       {
    //         room_id: room_id,
    //       }
    //     )
    //     .then((res) => {
    //       let all = res.data;
    //       let list = all.data.list;

    //       console.log(list);

    //       for (let i = 0; i < list.length; i++) {
    //         if (list[i].user) {
    //           list[i].head = list[i].user.head;
    //           list[i].name = list[i].user.name;
    //           list[i].yl_id = list[i].user.yl_id;
    //         }
    //         if (list[i].num == -1) list[i].wheat_name = "陪伴位";
    //         if (list[i].num == 0) list[i].wheat_name = "主持位";
    //         if (list[i].num == 1) list[i].wheat_name = "一号麦";
    //         if (list[i].num == 2) list[i].wheat_name = "二号麦";
    //         if (list[i].num == 3) list[i].wheat_name = "三号麦";
    //         if (list[i].num == 4) list[i].wheat_name = "四号麦";
    //         if (list[i].num == 5) list[i].wheat_name = "五号麦";
    //         if (list[i].num == 6) list[i].wheat_name = "六号麦";
    //         if (list[i].num == 7) list[i].wheat_name = "七号麦";
    //         if (list[i].num == 8) list[i].wheat_name = "八号麦";
    //       }
    //       this.list = list;

    //       this.layout.loading = false;
    //     })
    //     .catch((err) => {
    //       // 失败
    //       this.layout.loading = false;
    //     });
    // },
    //前往修改页面
    editItem(obj) {
      this.$router.push({
        name: "set_manager_rule",
        query: {
          item: obj,
        },
      });
    },
    getListResult(e) {
      //   this.tableData = e.list[0];
      this.url_list = e.url_list;
      this.now_list = e.now_list;

      this.datasort(e.list);
      //   console.log(e);
    },
    // 排序
    datasort(value) {
      let alldata = JSON.parse(JSON.stringify(value));
      if (alldata.length == 1 && alldata[0].data) {
        let data = alldata[0].data;

        this.tableData = [];
        for (let i in data) {
          this.tableData.push({
            value: i,
            quantity: data[i],
          });
        }
        this.tableData.sort((a, b) => {
          return b.quantity - a.quantity;
        });
      } else {
        this.tableData = [];
      }
      this.restaurants = this.tableData;
      //   console.log(this.tableData);
    },
    // 筛选条件
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return this.tableData;
    },
    handleSelect(item) {
      // 模糊搜索选中后
      let title = "";
      if (item) {
        title = "网址：" + item.value + "，" + "数量：" + item.quantity;
      } else {
        title = "暂无数据";
      }
      this.$alert(title, "来源搜索", {
        confirmButtonText: "确定",
        callback: () => {},
      });
      console.log(item);
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        user_id: "",
        out_trade_no: "",
        type: 0,
        pay_type: 0,
        is_error: -1,
        is_win: -1,
        time: "",
      };

      //   this.$refs.buttonSearch.closeSuperSearch();
      this.search = "";
      this.getList();
    },
    // 选择图片
  },
};
</script>

<style lang="scss" scoped>
.sertop {
  display: flex;
  align-items: center;
  padding-top: 20px;
  justify-content: space-between;
  .sertop-left {
    span {
      font-size: 14px;
    }
  }
  .sertop-right {
    .el-form {
      display: flex;
      align-items: center;
    }
  }
}
.tabsle {
  width: 100%;
  height: 600px;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  border-right: 1px solid #f2f2f2;
  .tabsle-cons {
    width: calc(100% / 3);
    padding: 10px 0;
    display: flex;
    min-width: 0;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f2f2f2;
    border-left: 1px solid #f2f2f2;
    span {
      padding: 0 20px;
      color: #606266;
    }
    span:nth-of-type(1) {
      font-size: 14px;
      color: #848588de;
    }
    span:nth-of-type(2) {
      width: 100px;
      text-align: center;
    }
    .el-button {
      flex: 1;
      max-width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      border: none;
      background-color: transparent;
      border-left: 1px solid #f2f2f2;
      border-right: 1px solid #f2f2f2;
    }
    // span:nth-of-type(1) {
    //   flex: 1;
    //   max-width: 80%;
    //   word-wrap: break-word;
    //   word-break: normal;
    // }
  }
  .tabsle-cons:nth-of-type(2n) {
    background-color: #409eff0d;
  }
  .tabsle-none {
    width: 100%;
    min-width: 0;
    padding: 150px 0;
    p {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #505357e0;
    }
  }
}
</style>
